import { TextBlock as TextBlock$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const TextBlock = createRemoteReactComponent(TextBlock$1);

export { TextBlock };
